import React, { Component } from 'react';
import _ from 'underscore';
import Loader from '../../components/Loader/Loader';
import * as cms from '../../shared/repos/cms/cms';
import cmsKeys from '../../shared/constants/cms';
import { getKeyValue } from '../../shared/utilities/cms';

import styles from './IceCreamChallenge.module.css'
import CmsInlineEdit from '../../components/Cms/CmsInlineEdit';


class IceCreamChallenge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      content: []
    };
  }

  componentDidMount() {
    cms.getContent([cmsKeys.iceCreamChallengePage], this);
  }

  render() {
    const { content, loading } = this.state;

    if (loading) {
      return (
        <div className={styles.pageWrapper}>
          <div className={styles.pageContainer}>
            <Loader id="loader" />
          </div>
        </div>
      );
    }

    if (!loading && !content.length) {
      return (
        <div className={styles.pageWrapper}>
          <div className={`${styles.pageContainer} text-dark dark:text-white`}>
            <h1>Oops, No data found for this page</h1>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.pageWrapper}>
        <div className={`${styles.pageContainer} text-dark dark:text-white`}>
          {content.map(iceCreamChallengePage => {
            const sections = getKeyValue(iceCreamChallengePage.children, 'sections', true);
            const mainTitle = _.find(iceCreamChallengePage.children, { key: 'title' });
            const subTitle = _.find(iceCreamChallengePage.children, { key: 'subtitle' });
            const mainBody = _.find(iceCreamChallengePage.children, { key: 'body' });
            return (
              <div>
                <div className={styles.pageSection}>
                  <h1 className='text-center'><CmsInlineEdit cmsNode={mainTitle}>{mainTitle?.value}</CmsInlineEdit></h1>
                  <h3 className='text-center'><CmsInlineEdit cmsNode={subTitle}>{subTitle?.value}</CmsInlineEdit></h3>
                  <p><CmsInlineEdit cmsNode={mainBody}>{mainBody?.value}</CmsInlineEdit></p>
                </div>

                {sections.children.map(iceCreamChallengeSection => {
                  const header = _.find(iceCreamChallengeSection.children, { key: 'header' });
                  const body = _.find(iceCreamChallengeSection.children, { key: 'body' });
                  return (
                    <div>
                      {(iceCreamChallengeSection.children.length > 0) ? (
                        <div className={styles.pageSection}>
                          <h3><CmsInlineEdit cmsNode={header}>{header?.value}</CmsInlineEdit></h3>
                          <p><CmsInlineEdit cmsNode={body}>{body?.value}</CmsInlineEdit></p>
                        </div>
                      ) : ''}
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </div>
    );
  }
}

export default IceCreamChallenge
